module.exports = __webpack_public_path__ + "static/media/lighten.a59c661e.png";